var MDB = window.MDB || {};
MDB.EmailCampaign = MDB.EmailCampaign || {};

(function() {

    var _editorModalBody,
        _editorModalSaveButton,
        _editorModalCancelButton,
        _editorModalTitle,
        _editorModalSubheader,
        _newGrid,
        _activeGrid,
        _inactiveGrid,
        _editorModal,
        _Editor = {
            Selection: 0,
            EmailCampaign: 1,
            Manual: 2
        },
        _newCampaignForm,
        _selection,
        _config;

    var _EmailCampaignType = {
        Once: 0,
        Continuously: 1,
        Manual: 2
    };

    var _EmailCampaignState = {
        New: 0,
        Active: 1,
        Paused: 2,
        Inactive: 3
    };

    var _KendoButtonType = {
        Edit: "edit",
        Delete: "delete",
        Pause: "pause",
        Activate: "activate",
        Reuse: "reuse"
    };

    $.extend(MDB.EmailCampaign,
        {
            boot: function (config) {
                _config = config;
                _editorModal = $('#editor-modal');
                _editorModalBody = _editorModal.find('#editor-modal-body');
                _editorModalSaveButton = _editorModal.find('#editor-save-btn');
                _editorModalCancelButton = _editorModal.find('#editor-cancel-btn');
                _editorModalTitle = _editorModal.find('#editor-modal-title');
                _editorModalSubheader = _editorModal.find('#editor-modal-subheader');
                _selection = $('#SelectionId');

                var grids = {
                    newGrid: $('#new-campaigns-grid'),
                    activeGrid: $('#active-campaigns-grid'),
                    inactiveGrid: $('#inactive-campaigns-grid')
                };

                MDB.EmailCampaign.initGrid(grids.newGrid, _EmailCampaignState.New).done(function () {
                    _newGrid = MDB.KendoConfigBuilder.getKendoWidget(grids.newGrid);
                });

                MDB.EmailCampaign.initGrid(grids.activeGrid, _EmailCampaignState.Active).done(function () {
                    _activeGrid = MDB.KendoConfigBuilder.getKendoWidget(grids.activeGrid);
                });

                MDB.EmailCampaign.initGrid(grids.inactiveGrid, _EmailCampaignState.Inactive).done(function() {
                    _inactiveGrid = MDB.KendoConfigBuilder.getKendoWidget(grids.inactiveGrid);
                });

                MDB.EmailCampaign.loadCampaignEditor();
            },
            activateClick: function(button) {
                MDB.UI.Loader.show();
            
                var id = $(button.closest('tr').children()[0]).html();
                MDB.EmailCampaign.getCampaignType(id)
                    .always(function(){
                        MDB.UI.Loader.hide(); 
                    })
                    .done(function (data) {
                        if (data.response === _EmailCampaignType.Manual) {
                            MDB.EmailCampaign.loadManualSettingsModal(id);
                        } else {
                            MDB.EmailCampaign.sendRequest(_config.changeCampaignStateUrl, {
                                id: encodeURIComponent(id), 
                                state: encodeURIComponent(_EmailCampaignState.Active) 
                            }).done(function (data) {
                                MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_Index_Campaign_Activated_Text'));
                                _activeGrid.dataSource.read();
                                _newGrid.dataSource.read();
                            });
                        } 
                    });
            },
            pauseClick: function (button) {
                var id = $(button.closest('tr').children()[0]).html();

                MDB.EmailCampaign.sendRequest(_config.changeCampaignStateUrl, {
                    id: encodeURIComponent(id), 
                    state: encodeURIComponent(_EmailCampaignState.Paused)
                }).done(function (data) {
                    MDB.Notify.bootstrapInfo(MDB.loadResourceString('Dpn_EmailCampaign_Index_Campaign_Paused_Text'));
                    _activeGrid.dataSource.read();
                });
            },
            reuseClick: function (button) {
                var id = $(button.closest('tr').children()[0]).html();

                MDB.EmailCampaign.sendRequest(_config.changeCampaignStateUrl, {
                    id: encodeURIComponent(id), 
                    state: encodeURIComponent(_EmailCampaignState.New)
                }).done(function (data) {
                    MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_Index_Campaign_Reused_Text'));
                    _newGrid.dataSource.read();
                    _inactiveGrid.dataSource.read();
                });
            },
            archiveClick: function (button) {
                var id = $(button.closest('tr').children()[0]).html();

                MDB.EmailCampaign.sendRequest(_config.changeCampaignStateUrl, { 
                    id: encodeURIComponent(id),
                    state: encodeURIComponent(_EmailCampaignState.Inactive)
                }).done(function (data) {
                    MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_Index_Campaign_Archived_Text'));
                    _activeGrid.dataSource.read();
                    _inactiveGrid.dataSource.read();
                });
            },
        editClick: function(button, canEdit) {
                canEdit = canEdit == undefined ? true : canEdit;
                var id = $(button.closest('tr').children()[0]).html();
                var grid = MDB.KendoConfigBuilder.getKendoWidget($(button.closest('.k-grid')));
                MDB.EmailCampaign.loadEditModal(id, grid, canEdit);
            },
            deleteClick: function(button) {
                var id = $(button.closest('tr').children()[0]).html();

                MDB.promptHtml(
                    MDB.loadResourceString('Dpn_EmailCampaign_Index_Delete_Campaign_Prompt_Title'), 
                    '<h4><i class="fa fa-trash text-danger"></i> <small>' + 
                MDB.loadResourceString('Dpn_EmailCampaign_Index_Delete_Campaign_Prompt_Body') + '</small></h4>', 
                
                    function(ok){
                        if (ok) {
                            var grid = button.closest('.k-grid');
                            MDB.EmailCampaign.executeDelete(id, MDB.KendoConfigBuilder.getKendoWidget(grid));
                        }
                    });
            },
            historyClick: function(button) {
                var id = $(button.closest('tr').children()[0]).html();
            
                var modal = MDB.modal({
                    shapeHtml: function(html){
                        html = $(html);

                        html.find('.modal-header')
                            .prepend('<h4>'+ MDB.loadResourceString('Dpn_EmailCampaign_Index_History_Title') +'</h4>');
                    
                        return html;
                    }
                });
            
                MDB.EmailCampaign.initializeLoadingModal(modal);
            
                var history = MDB.EmailCampaign.sendRequest(_config.getHistoryUrl, {id : id})
                    .done(function(response) {
                        if(response.errors.length > 0) {
                            MDB.Notify.bootstrapDanger(MDB.loadResourceString('Generic_Error_Text'));
                        
                            //We won't be needing our modal anymore
                            MDB.killOpenModals();
                        
                            console.warn(response.errors.join(':::: '));
                        
                            return;
                        }

                        var body = modal.find('.modal-body');
                    
                        //Remove loading notification
                        body.empty();

                        body.append('<h4><i class="fa fa-history"></i> '+ MDB.loadResourceString('Dpn_EmailCampaign_Index_History_Subtitle') +'</h4>');

                        body.append('<table name="history" class="table table-striped">' +
                        '<thead>' +
                        '<tr>' +
                        '<td>' + MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignHistory_Sent_DisplayName') + '</td>' +
                        '<td>' + MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignHistory_Amount_DisplayName') + '</td>' +
                        '<td>' + MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignHistory_Total_DisplayName') + '</td>' +
                        '</tr>' +
                        '</thead>'+
                        '</table>');

                        var table = body.find('[name="history"]');
                    
                        response.value.forEach(function(item){
                            table.append('<tr>' +
                            '<td>' + item.SentValue + '</td>' +
                            '<td>' + item.Amount + '</td>' +
                            '<td>' + item.Total + '</td>' +
                            '</tr>');
                        });

                        modal.modal('show');
                    });

            },
        viewClick: function (button) {
            MDB.EmailCampaign.editClick(button, false);
        },
            sendTestRecordClick: function(button){
                var model = MDB.KendoConfigBuilder.findGridRowModel(button);
                
                var promptTitle = MDB.loadResourceString('Dpn_EmailCampaign_Index_PromptTestRecord_Title');
                var promptBody = MDB.loadResourceString('Dpn_EmailCampaign_Index_PromptTestRecord_Body');

                MDB.prompt(promptTitle, promptBody, function(ok) {
                    if(!ok) {
                        return;
                    }

                    var url = _config.sendTestRecordUrl;

                    //String.prototype does not contain endsWith in IE
                    var endsWith = String.prototype.endsWith || function(value){
                        return this.indexOf(value) === this.length - 1;
                    };

                    //For the time being; assume our URL does not contain a querystring
                    if(!endsWith.call(url, '/')){
                        url += '/';
                    }

                    url += model.id;

                    MDB.EmailCampaign.sendRequest(url, {}, 'POST').done(function(){
                        MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_Index_TestRecord_Created_Text'));
                    });
                });
            },
            initSelectionTooltip: function(selector) {
                var selectionInfo = selector.find('#selection-info');
                var selection = selector.find('#SelectionId');

                selection.unbind('change');
                selection.change(function(){
                    MDB.EmailCampaign.loadTooltip(selectionInfo, selection.val().split('|')[1], 
                        { 
                            placement: 'bottom', container: selector[0].id === '' ? 'body' : '#' + selector.prop('id') 
                        });
                });

                if(selection.val() !== null) {
                    MDB.EmailCampaign.loadTooltip(selectionInfo, selection.val().split('|')[1], 
                        { 
                            placement: 'bottom', container: selector[0].id === '' ? 'body' : '#' + selector.prop('id') 
                        });
                }
            },
            initButtons: function (selector) {
                if(selector[0].id === '') {
                    var submit = $('#submit-campaign-btn');
                    submit.click(function(e) {
                        e.preventDefault();
                        MDB.EmailCampaign.submitCampaign($('#new-campaign-form'), true).done(function(done){
                            MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_Index_Campaign_Added_Text'));
                            _newGrid.dataSource.read();
                        });
                    });

                    submit.mouseleave(function() {
                        submit.tooltip('hide');
                    });
                }

                var selection = selector.find('#request-selection-btn');

                selection.unbind('click');
                selection.click(function(e) {
                    e.preventDefault();
                    MDB.EmailCampaign.loadSelectionRequestModal(_config);
                });

                var addSettingsBtn = selector.find('[name="btn-add-setting"]');
                addSettingsBtn.unbind('click');
                addSettingsBtn.click(function(e) {
                    e.preventDefault();
                    MDB.EmailCampaign.addSettingsRow(selector.find('[name="settings-editor"]'));
                });

            },
            loadTooltip: function (selector, text, opts) {
                if (opts === undefined) {
                    opts = {
                        placement: 'bottom'
                    };
                }

                selector.tooltip(opts);

                selector.hover(function () {
                    selector.attr('data-original-title', text);
                    selector.tooltip('show');
                });

                selector.mouseleave(function () {
                    selector.tooltip('hide');
                });

                selector.attr('data-original-title', text); 
            },
            initKendoTooltips: function (kendoGrid) {
                kendoGrid.tbody.find('tr').each(function() {
                    var me = $(this);

                    var activateBtns = me.find('.btn-activate');
                    
                    activateBtns.each(function (index, button) {
                        button = $(button);

                        if(button.is(':disabled')) { 
                            //browser does not register mouseenter for disabled elements. So this doesn't actually work, unfortunatly
                            //I ran out of time to find a workaround and no one has complained about the abcense of a tooltip.
                            MDB.EmailCampaign.loadTooltip(button, MDB.loadResourceString('Dpn_EmailCampaign_Invalid_Selection_Error_Text'));
                        } else {
                            MDB.EmailCampaign.loadTooltip(button, MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Activate_Tooltip'));
                        }
                    });

                    MDB.EmailCampaign.loadTooltip(me.find('.btn-edit'), MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Edit_Tooltip'));
                    MDB.EmailCampaign.loadTooltip(me.find('.btn-archive'), MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Archive_Tooltip'));
                    MDB.EmailCampaign.loadTooltip(me.find('.btn-history'), MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_History_Tooltip'));
                    MDB.EmailCampaign.loadTooltip(me.find('.btn-delete'), MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Delete_Tooltip'));
                    MDB.EmailCampaign.loadTooltip(me.find('.btn-pause'), MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Pause_Tooltip'));
                    MDB.EmailCampaign.loadTooltip(me.find('.btn-reuse'), MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Reuse_Tooltip'));
                    MDB.EmailCampaign.loadTooltip(me.find('.btn-test-record'), MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_SendTestRecord_Tooltip'));

                    var refreshBtn = me.find('.count-refresh-btn').click(function(){
                        var $btn = $(this);
                        $btn.addClass('fa-spin');
                            
                        var  params = {
                            id: me.children().first().html(),
                            type: $btn.data('type')
                        };
                            
                        MDB.EmailCampaign.sendRequest(_config.updateCountUrl, params)
                            .always(function(){
                                $btn.removeClass('fa-spin'); 
                            })    
                            .done(function(data){
                                me.find('.count-lbl').text(data.response);
                            });
                    });

                });
            },
            addSettingsRow: function(editor) {
                var rowsExist = editor.children().length != 0;

                var pattern =/\[(\d+)\]/;
                var template = rowsExist ? editor.children().last().prop('outerHTML') : $('#row-template').clone().html();
                var last =  parseInt(pattern.exec(template)[1]);

                //replace values in template
                template = template
                    .replace(new RegExp('{i}', 'g'), last+1)
                    .replace(new RegExp('{serialize}', 'g'), 'serialize')
                    .replace(new RegExp('\\[\\d+\\]', 'g'), '[' + (last+1) + ']')
                    .replace(new RegExp('_\\d+__', 'g'), '_' + (last+1) + '__')
                    .replace(new RegExp('data-index="\\d+"', 'g'), 'data-index="'+ (last+1) +'"');

                editor.append(template);
                console.log(editor.children().last());
                editor.children().last().find('[type="text"]').val('');

                if(!rowsExist) {
                    $('[name="editor-labels"]').removeClass('hidden');
                }

                //Re-add validation
                var form = editor.parents('.campaign-form').first();
                form.removeData(['validator', 'unobtrusiveValidation']);
                $.validator.unobtrusive.parse(form);
            },
            removeSettingsRow: function(btn) {
                var me = $(btn);
                var editor = me.parents('[name="settings-editor"]');
            
                me.parents('.row').first().remove();
            
                if(editor.children().length == 0) {
                    $('[name="editor-labels"]').addClass('hidden');
                }
            },
            submitCampaign: function(form, isNew) {
                var def = $.Deferred();

                if(form.valid()) {
                    var model = MDB.EmailCampaign.buildCampaignModel(form.find('.serialize:not(#SelectionId, .k-widget)'));
                    model.SelectionId = form.find('#SelectionId').val().split('|')[0];

                    $.ajax({
                        type: "POST",
                        url: isNew ? _config.submitCampaignUrl : _config.editCampaignUrl,
                        contentType: "application/json",
                        data: JSON.stringify(model),
                        processData: false,
                        dataType: "json",
                        success: function (data) {
                            if (data.errors.length > 0) {
                                def.reject();
                                
                                //Ensure our popup always contains at least some text
                                MDB.Notify.bootstrapDanger(
                                    data.errors.join(', ') || 
                                    MDB.loadResourceString('Generic_Error_Text')
                                );
                            } else {
                                def.resolve(data);
                                MDB.EmailCampaign.clearForm(form);
                            }
                        },
                        error: function () {
                            def.reject();
                            MDB.Notify.bootstrapDanger(MDB.loadResourceString('Generic_Error_Text'));
                        }
                    });  
                } else {
                    def.reject();
                }
                return def.promise();
            },
            buildCampaignModel: function(model) {
                var arrProps = {};
                var modelObject = {};

                model.each(function (i) {
                    var me = $(this);

                    if(me.data('type') == 'array') {
                        var name = this.name.split('[')[0];
                        var property = this.name.split('.')[1];
                        var arrIdx = this.name.split('[')[1].split(']')[0];

                        var nameArr = arrProps[name] || {};
                        arrProps[name] = nameArr;

                        var arrObj = {};
                        if( nameArr[arrIdx]){
                            arrObj =  nameArr[arrIdx];
                        }

                        arrObj[property] = me.val();
                        nameArr[arrIdx] = arrObj;
                    } else {
                        modelObject[this.name] = me.val();
                    }
                });

                _.forEach(_.keys(arrProps), function(key){
                    var targetArr = modelObject[key];
                    if(!targetArr){
                        targetArr = modelObject[key] = [];
                    }

                    _.forEach(arrProps[key], function(item){
                        targetArr.push(item);    
                    });                    
                });
                return modelObject;
            },
            addOptionToSelection: function(id, name, description){
                var selectionValue = id + '|' + description;
            
                _selection.append(
                    ['<option class="text-info" style="font-style: italic;" value="', selectionValue, '">',
                        name,' ',MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequestResponseModel_SelectionRequested_Text'),
                        '</option>']
                        .join(''));
            
                _selection.val(selectionValue);
            },
            loadSelectionRequestModal: function() {
                _editorModalBody.load(_config.getEditorUrl + '?editor=' + encodeURIComponent(_Editor.Selection), function () {
                
                    _editorModalTitle.html(MDB.loadResourceString('Dpn_EmailCampaign_Index_SelectionRequest_Title'));
                
                    _editorModalSubheader.html('<i class="fa fa-plus-square"></i> ' +
                    MDB.loadResourceString('Dpn_EmailCampaign_Index_SelectionRequest_Subheading'));

                    _editorModalCancelButton.prop('class', 'btn btn-danger');
                    _editorModalCancelButton.html(MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequest_Button_Cancel_DisplayText'));

                    _editorModalSaveButton.prop('class', 'btn btn-success');
                    _editorModalSaveButton.html(MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequest_Button_Request_DisplayText'));
                    _editorModalSaveButton.unbind('click');
                    _editorModalSaveButton.click(function () {
                        var form = $('#request-selection-form');
                        var model = form.serialize();
                        MDB.EmailCampaign.loadSelectionResponseModal(_config.selectionRequestUrl + '?' + model);
                    });

                    _editorModalSaveButton.show();

                    MDB.EmailCampaign.loadTooltip(_editorModalCancelButton, MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequest_Button_Cancel_Tooltip'),
                        { placement: 'bottom', container: '#editor-modal' });

                    MDB.EmailCampaign.loadTooltip(_editorModalSaveButton, MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequest_Button_Request_Tooltip'),
                        { placement: 'bottom', container: '#editor-modal' });

                    _editorModal.modal('show');
                });
            },
            loadSelectionResponseModal: function(url) {
                _editorModalBody.html('');
                _editorModalBody.load(url, function (response, status, xhr) {
                
                    //Load is not guaranteed to succeed
                    //Close our modal and display an error in case of an error
                    var mainStatusDigit = Math.floor(xhr.status / 100);
                    if (mainStatusDigit == 4 || mainStatusDigit == 5) {
                    // we consider 4xx & 5xx to be errors. 
                        MDB.killOpenModals();
                        MDB.Notify.bootstrapDanger(MDB.loadResourceString('Generic_Error_Text'));
                        return;
                    }

                    var id = _editorModalBody.find('#Selection_Id').val(),
                        name = _editorModalBody.find('#Selection_Name').val(),
                        description = _editorModalBody.find('#Selection_Description').val();

                    MDB.EmailCampaign.addOptionToSelection(id, name, description);

                    _editorModalTitle.html(MDB.loadResourceString('Dpn_EmailCampaign_Index_SelectionRequest_Title'));
                
                    _editorModalSubheader.html(MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequest_Response_Title'));

                    _editorModalCancelButton.prop('class', 'btn btn-secondary');
                    _editorModalCancelButton.html(MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequest_Button_Close_DisplayText'));

                    _editorModalSaveButton.hide();

                    MDB.EmailCampaign.loadTooltip(_editorModalCancelButton, MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequest_Button_Close_Tooltip'),
                        { placement: 'bottom', container: '#editor-modal' });

                    if(id !== undefined){
                        MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequest_Success_Text'));
                    }
                });
            },
            loadManualSettingsModal: function (id) {
                _editorModalBody.html('');
                _editorModalBody.load('/DPN/EmailCampaign/GetEditor' + '?editor=' + 
                encodeURIComponent(_Editor.Manual) + '&campaignId=' + 
                encodeURIComponent(id), function () {

                    _editorModalTitle.html(MDB.loadResourceString('Dpn_EmailCampaign_ManualSettings_Editor_Title'));
                
                    _editorModalSubheader.html('<i class="fa fa-envelope text-warning"></i> ' +
                    MDB.loadResourceString('Dpn_EmailCampaign_ManualSettings_Editor_Subheader'));

                    _editorModalCancelButton.prop('class', 'btn btn-danger');
                    _editorModalCancelButton.html(MDB.loadResourceString('Dpn_EmailCampaign_ManualSettings_Editor_Button_Cancel_Text'));

                    _editorModalSaveButton.show();
                    _editorModalSaveButton.prop('class', 'btn btn-success');
                    _editorModalSaveButton.html(MDB.loadResourceString('Dpn_EmailCampaign_ManualSettings_Editor_Button_Activate_Text'));
                
                    _editorModalSaveButton.unbind('click');
                    _editorModalSaveButton.click(function(e) {
                        e.preventDefault();
                        MDB.EmailCampaign.manualEditorSaveBtnClick(id);
                    });

                    MDB.EmailCampaign.loadManualSettingsSliders();
                    MDB.EmailCampaign.loadManualSettingsResetButtons();

                    MDB.EmailCampaign.loadTooltip(_editorModalCancelButton, MDB.loadResourceString('Dpn_EmailCampaign_ManualSettings_Editor_Button_Cancel_Tooltip'),
                        {placement: 'bottom', container: '#editor-modal'});

                    MDB.EmailCampaign.loadTooltip(_editorModalSaveButton, MDB.loadResourceString('Dpn_EmailCampaign_ManualSettings_Editor_Button_Activate_Tooltip'),
                        {placement: 'bottom', container: '#editor-modal'});

                    _editorModal.modal('show');
                });
            },
        loadEditModal: function (id, kendoGrid, canEdit) {
                _editorModalBody.html('');

            var header = canEdit ? 
            MDB.loadResourceString('Dpn_EmailCampaign_Campaign_Editor_Title') : 
            MDB.loadResourceString('Dpn_EmailCampaign_Campaign_Viewer_Title');
            
            var subheader =  canEdit ? 
            MDB.loadResourceString('Dpn_EmailCampaign_Campaign_Editor_Subheader') : 
            MDB.loadResourceString('Dpn_EmailCampaign_Campaign_Viewer_Subheader');

                MDB.EmailCampaign.initializeLoadingModal(_editorModalBody);
                _editorModal.modal('show');

            _editorModalTitle.text(header);
            _editorModalSubheader.html('<i class="fa fa-envelope text-warning"></i> ' + subheader);
            _editorModalCancelButton.prop('class', 'btn btn-danger');
            _editorModalCancelButton.html(MDB.loadResourceString('Dpn_EmailCampaign_Campaign_Editor_Button_Cancel_Text'));

            _editorModalSaveButton.show();
            _editorModalSaveButton.prop('class', 'btn btn-success');
            _editorModalSaveButton.text(MDB.loadResourceString('Dpn_EmailCampaign_Campaign_Editor_Button_Save_Text'));
            _editorModalSaveButton.unbind('click');

                _editorModalBody.load('/DPN/EmailCampaign/GetEditor' + '?editor=' + _Editor.EmailCampaign + '&campaignId=' + id, function (response, status) {
                //https://api.jquery.com/load/#example-1
                    if (status === "error") {
                        _editorModal.modal('hide');
                        MDB.Notify.bootstrapDanger(MDB.loadResourceString('Generic_Error_Text'));
                        return;
                    }

                    var form = $('#edit-campaign-form');

                if(canEdit) {
                    _editorModalSaveButton.click(function() {
                        MDB.EmailCampaign.submitCampaign(form, false).done(function(data){
                            if(data.response) {
                                MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_Campaign_Editor_Saved_Success_Text'));
                                kendoGrid.dataSource.read();
                            }
                            _editorModal.modal('hide');
                        });
                    });
                    _editorModalSaveButton.show();
                    _editorModalCancelButton.show();
                } else {
                    _editorModalSaveButton.hide();
                    _editorModalCancelButton.hide();
                }

                    MDB.EmailCampaign.loadCampaignEditor(form).done(function(){
                        MDB.EmailCampaign.loadTooltip(form.find('#request-selection-btn'), MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Request_Selection_Tooltip'), 
                            {placement: 'bottom', container: '#editor-modal'});

                    var selectedOfferings = form.find('#model-offerings').text().split(',');
                    var selectedTitles = form.find('#model-titles').text().split(',');
                    var selectedFields = form.find('#model-fields').text().split(',');

                    var offerings = form.find('#Offerings');
                        var freeFields = form.find('#FreeFields');
                    var titles = form.find('#Titles');
                    var startDate = form.find('#StartValue');

                        var freeFieldGroups = form.find('#freefield-groups');

                    MDB.initKendoDatePickers(form);
                    MDB.initKendoMultiSelects(form);

                    offerings.data('kendoMultiSelect').value(selectedOfferings);
                    freeFields.data('kendoMultiSelect').value(selectedFields);
                    titles.data('kendoMultiSelect').value(selectedTitles);

                        MDB.EmailCampaign.initFreeFieldsGroup(freeFieldGroups, freeFields);

                        var selectionId = form.find('#selection-id-value').val();
                        form.find('#SelectionId > option').each(function(i) {
                            var me = $(this);
                        
                            if(me.val().split('|')[0] == selectionId) {
                                me.parent().prop('selectedIndex', i);
                                me.parent().change();
                            }
                        });

                    if(!canEdit) {
                        titles.data("kendoMultiSelect").enable(false);
                        offerings.data("kendoMultiSelect").enable(false);
                        freeFields.data("kendoMultiSelect").enable(false);
                        startDate.data("kendoDatePicker").enable(false);

                        form.find('input,select,#title-select-all,button[name="btn-add-setting"]').attr('disabled', true);
                        form.find('.delete,#request-selection-container').hide();
                    } else {
                        form.find("#title-select-all").click(function(e) {
                            e.preventDefault();
                            var values = $.map(titleSelect.dataSource.data(), function(dataItem) {
                                    return dataItem.value;
                                });
                            titleSelect.value(values);
                        });
                    }
                    });
                });
            },
            getCampaignType: function (id) {
                return MDB.EmailCampaign.sendRequest(_config.getTypeUrl, { id: encodeURIComponent(id)}).done();
            },
            loadCampaignEditor: function (selector) {
                var def = $.Deferred();

                var loadMultiSelects = false;
                if(selector === undefined){
                    selector = $('body');
                    loadMultiSelects = true;
                }

                MDB.EmailCampaign.initButtons(selector, _config);

            // selector.find('#StartValue').kendoDatePicker({
            //     dateInput: true,
            //     format: 'dd-MM-yyyy',
            //     parseFormats: ["dd MM yyyy"]
            // });

                selector.find('#SelectionId').find('option').each(function(){
                    var me = $(this);
                    if(me.text().includes(MDB.loadResourceString('Dpn_EmailCampaign_SelectionRequestResponseModel_SelectionRequested_Text'))) {
                        me.prop('class', 'text-info');
                        me.prop('style', 'font-style: italic;');
                    }
                });

                MDB.initBootstrapSwitchesDependantControls(selector.find('.enable-switch'));

                if(loadMultiSelects) {
                    var freeFields = selector.find('#FreeFields');
                    var freeFieldGroups = selector.find('#freefield-groups');

                    MDB.EmailCampaign.initFreeFieldsGroup(freeFieldGroups, freeFields);
    
                    selector.find("#title-select-all").click(function(e) {
                        e.preventDefault();
                        
                        //Our multiSelect is not guaranteed to have been initialised upon load
                        var titles = selector.find('#Titles').data('kendoMultiSelect');
                        
                        var values = $.map(titles.dataSource.data(), function(dataItem) {
                            return dataItem.value;
                        });
                        
                        titles.value(values);
                    });
                }

                MDB.EmailCampaign.initSelectionTooltip(selector);
                def.resolve();
                return def.promise();
            },
            initFreeFieldsGroup: function (freeFieldGroups, freeFields) {
                freeFieldGroups.change(function() {
                    var groups = JSON.parse(_config.freeFieldGroups);
                    var group = _.find(groups, {Name: freeFieldGroups.val()});
                    
                    if(group == null) {
                        freeFields.data('kendoMultiSelect').value('');
                        return;
                    }
                    var newFields = _.union(group.Fields, freeFields.val());
                    freeFields.data('kendoMultiSelect').value(newFields);
                });
            },
            loadManualSettingsSliders: function () {
                $('.percentage-slider').each(function (i, item) {
                    var slider = $(item);

                    slider.slider({
                        formatter: function (value) {
                            return 'Current value: ' + value;
                        }
                    });

                    var name = slider.attr('id').split('-')[0];
                    var max = parseFloat($('#' + name + '-max').val());

                    slider.unbind('change');
                    slider.on("change", function () {
                        $('#' + name + '-percentage').val(slider.val());
                        $('#' + name + '-count').val(Math.ceil(max / 100 * parseFloat(slider.val())));
                        triggerAllSliders(name, slider.val());
                    });
                });

                $('.slider-percentage').each(function (i, item) {
                    var percentage = $(item);
                    var name = percentage.attr('id').split('-')[0];
                    var max = parseFloat($('#' + name + '-max').val());

                    percentage.unbind('change mouseup');
                    percentage.on('keyup mouseup', function () {
                        MDB.EmailCampaign.parsePercentageInput(percentage, 100);
                        $('#' + name + '-slider').slider('setValue', parseFloat(percentage.val()));
                        $('#' + name + '-count').val(Math.ceil(max / 100 * parseFloat(percentage.val())));
                        triggerAllSliders(name, percentage.val());
                    });
                });

                $('.slider-count').each(function (i, item) {
                    var count = $(item);
                    var name = count.attr('id').split('-')[0];
                    var max = parseFloat($('#' + name + '-max').val());

                    count.unbind('keyup');
                    count.keyup(function () {
                        MDB.EmailCampaign.parsePercentageInput(count, max);
                        var percentage = parseFloat(count.val()) * 100 / max;

                        $('#' + name + '-percentage').val(percentage);
                        $('#' + name + '-slider').slider('setValue', percentage);
                        triggerAllSliders(name, percentage.val());
                    });
                });

                function triggerAllSliders(name, percentage) {
                    if(name == MDB.loadResourceString('Dpn_EmailCampaign_ManualSettings_All_DisplayName')) {
                        $('.percentage-slider').each(function () {
                            var thisSlider = $(this);
                            thisSlider.slider('setValue', parseFloat(percentage));
                            var sliderName = thisSlider.attr('id').split('-')[0];
                            var currentMax =  $('#' + sliderName + '-max').val();

                            $('#' + sliderName + '-percentage').val(thisSlider.val());
                            $('#' + sliderName + '-count').val(Math.ceil(currentMax / 100 * parseFloat(thisSlider.val())));
                        });
                    }
                }
            },
            loadManualSettingsResetButtons: function() {
                $('.manual-reset-btn').each(function (i, btn) {
                    var me = $(btn);
                    me.unbind('click');
                    me.click(function (e) {
                        var name = me.attr('id').split('-')[0],
                            percentage = $('#' + name + '-percentage'),
                            count = $('#' + name + '-count'),
                            max = $('#' + name + '-max').val(),
                            slider = $('#' + name + '-slider');

                        slider.slider('setValue', 100);
                        count.val(max);
                        percentage.val(100);
                    });
                });
            },
            parsePercentageInput: function(me, max) {
                if (me.val() > max) {
                    me.val(max);
                } else if (me.val() < 0) {
                    me.val(0);
                }
            },
            manualEditorSaveBtnClick: function(id) {
                $('.slider-percentage').each(function (i, txt) {
                    var percentage = $(txt);
                    if (percentage.val() === "") {
                        percentage.val(0);
                    }
                });

                var values = [];
                $('.slider-count').each(function(i, counter){
                    var me = $(counter);
                    if (me.val() === "") {
                        me.val(0);
                    }

                    var name = me.prop('id').split('-')[0];

                    values.push({
                        name: name,
                        count: parseInt(me.val()),
                        max: parseInt($('#' + name + '-max').val())
                    });
                });

                _editorModal.modal('hide');
            
                MDB.EmailCampaign.sendRequest(_config.changeCampaignStateUrl, 
                    { 
                        id: encodeURIComponent(id),
                        state: encodeURIComponent(_EmailCampaignState.Active),
                        countValues: JSON.stringify(values)
                    }).done(function (data) {
                    MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_Index_Campaign_Activated_Text'));
                    _activeGrid.dataSource.read();
                    _newGrid.dataSource.read();
                });
            },
            executeDelete: function(id, kendoGrid){
                MDB.EmailCampaign.sendRequest(_config.deleteCampaignUrl, {id: encodeURIComponent(id)}).done(function(data){
                    MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_EmailCampaign_Index_Campaign_Removed_Text'));
                    kendoGrid.dataSource.read();
                });
            },
            sendRequest: function(url, data, method) {
                var def = $.Deferred();

                $.ajax({
                    type: method === undefined ? "GET" : method,
                    url: url,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: data,
                    success: function(data) {
                        if (data.errors.length > 0) {
                            //MDB.Notify.bootstrapDanger(MDB.loadResourceString('Generic_Error_Text'));
                            console.warn(data.errors.join(':::: '));
                            MDB.Notify.bootstrapDanger(data.errors.join('<br />'));
                            def.reject();
                        } else {
                            def.resolve(data);
                        }
                    },
                    error: function () {
                        MDB.Notify.bootstrapDanger(MDB.loadResourceString('Generic_Error_Text'));
                        def.reject();
                    }
                });
                return def.promise();
            },
        initializeLoadingModal: function(modal) {
                modal = $(modal);
          
                //Our target is either a modal, or part of a modal
                var target = modal.find('.modal-body');
                if(!target.length){
                    target = modal;
                }
            
                //Give a clear indication we're loading
                target.append(
                    '<div style="height: 50px">' +
                        '<div class="loading"></div>' +
                    '</div>'
                );
            
                return modal;
            },
            clearForm: function(form){
                form.find('.serialize:not(#StartValue,#Type,#State)').val('');

                var titles = form.find('#Titles').data('kendoMultiSelect');
                var offerings = form.find('#Offerings').data('kendoMultiSelect');
                var fields = form.find('#FreeFields').data('kendoMultiSelect');

                titles.value('');
                offerings.value('');
                fields.value('');

                //remove all added rows in advanced settings
                $('[name="remove-adv-setting"]').click();

                //If advanced settings are visible, re-hide
                if($('[name="btn-add-setting"]').is(':visible')) {
                    $('[name="ShowAdvancedSettings"]').click();
                }        
            }
        });
})();